module.exports = __webpack_public_path__ + "img/430.1b815b2e.jpg";